import Link from 'next/link';
import { ASSET_PREFIX, colors } from "utils/constants";
import React from "react";
import HeroImageBackgroundContainer from "components/HeroImageBackgroundContainer";

const TreesForFutureMessageGiftCards = ({ backgroundImage = `${ASSET_PREFIX}/images/hero-new.jpg`, promptText = 'For every entry included with your gift card' }) => (
  <HeroImageBackgroundContainer background={backgroundImage} style={{ flexDirection: 'row', color: 'white' }}>
    <img src={`${ASSET_PREFIX}/images/enter/giving-back.png`} style={{ height: '50px', marginRight: '1em' }} />

    <p style={{ maxWidth: '350px' }}>
      {promptText}, a tree is planted with {''}
      <Link href='/giving-back'>
        <a style={{ margin: 0, fontWeight: 'bold', color: 'inherit' }} target='_blank'>veritree</a>
      </Link>
      {''}.
    </p>

    <style jsx>{`
      p {
        font-weight: 600;
      }
    `}</style>
  </HeroImageBackgroundContainer>
);

export default TreesForFutureMessageGiftCards;